<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const { getNuxtLink, isExternal } = useCustomLink()
// for word search
const { data: searchPointList } = await useFetch('/api/city/search')

const { result, keyword } = useWordSearch((searchPointList?.value || []))
</script>

<template>
  <section class="clothesSearch">
    <SectionTitle title="エリアごとの服装予報" />
    <div
      class="inner"
    >
      <form
        class="form"
      >
        <label
          class="search"
        ><input
           id="search"
           v-model="keyword"
           type="text"
           placeholder="地点で検索"
           class="input"
         >
          <button
            type="button"
            class="submit"
            aria-label="検索"
            @click="() => {}"
          >
            <img
              src="https://gvs.weathernews.jp/clothes/images/icon/icon_search_white.svg"
              width="30"
              height="30"
              class="icon"
            >
          </button>
        </label>
        <ClothesSearchCandidate
          v-show="keyword !== ''"
          :result="result"
        />
      </form>
      <div
        class="contents"
      >
        <NuxtLink
          :to="getNuxtLink('/clothes/hokkaido/')"
          class="area"
        >北海道</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/hokkaido/douou/')"
            :external="isExternal('/clothes/hokkaido/douou/')"
            class="pref"
          >道央</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/hokkaido/dounan/')"
            :external="isExternal('/clothes/hokkaido/dounan/')"
            class="pref"
          >道南</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/hokkaido/douhoku/')"
            :external="isExternal('/clothes/hokkaido/douhoku/')"
            class="pref"
          >道北</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/hokkaido/doutou/')"
            :external="isExternal('/clothes/hokkaido/doutou/')"
            class="pref"
          >道東</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/tohoku/')"
          :external="isExternal('/clothes/tohoku/')"
          class="area"
        >東北</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/tohoku/aomori/')"
            :external="isExternal('/clothes/tohoku/aomori/')"
            class="pref"
          >青森</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/tohoku/iwate/')"
            :external="isExternal('/clothes/tohoku/iwate/')"
            class="pref"
          >岩手</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/tohoku/akita/')"
            :external="isExternal('/clothes/tohoku/akita/')"
            class="pref"
          >秋田</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/tohoku/miyagi/')"
            :external="isExternal('/clothes/tohoku/miyagi/')"
            class="pref"
          >宮城</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/tohoku/yamagata/')"
            :external="isExternal('/clothes/tohoku/yamagata/')"
            class="pref"
          >山形</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/tohoku/fukushima/')"
            :external="isExternal('/clothes/tohoku/fukushima/')"
            class="pref"
          >福島</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/kanto/')"
          :external="isExternal('/clothes/kanto/')"
          class="area"
        >関東</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/kanto/ibaraki/')"
            :external="isExternal('/clothes/kanto/ibaraki/')"
            class="pref"
          >茨城</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kanto/tochigi/')"
            :external="isExternal('/clothes/kanto/tochigi/')"
            class="pref"
          >栃木</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kanto/gunma/')"
            :external="isExternal('/clothes/kanto/gunma/')"
            class="pref"
          >群馬</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kanto/saitama/')"
            :external="isExternal('/clothes/kanto/saitama/')"
            class="pref"
          >埼玉</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kanto/chiba/')"
            :external="isExternal('/clothes/kanto/chiba/')"
            class="pref"
          >千葉</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kanto/tokyo/')"
            :external="isExternal('/clothes/kanto/tokyo/')"
            class="pref"
          >東京</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kanto/kanagawa/')"
            :external="isExternal('/clothes/kanto/kanagawa/')"
            class="pref"
          >神奈川</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/chubu/')"
          :external="isExternal('/clothes/chubu/')"
          class="area"
        >中部</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/chubu/yamanashi/')"
            :external="isExternal('/clothes/chubu/yamanashi/')"
            class="pref"
          >山梨</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/nagano/')"
            :external="isExternal('/clothes/chubu/nagano/')"
            class="pref"
          >長野</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/niigata/')"
            :external="isExternal('/clothes/chubu/niigata/')"
            class="pref"
          >新潟</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/toyama/')"
            :external="isExternal('/clothes/chubu/toyama/')"
            class="pref"
          >富山</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/ishikawa/')"
            :external="isExternal('/clothes/chubu/ishikawa/')"
            class="pref"
          >石川</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/fukui/')"
            :external="isExternal('/clothes/chubu/fukui/')"
            class="pref"
          >福井</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/shizuoka/')"
            :external="isExternal('/clothes/chubu/shizuoka/')"
            class="pref"
          >静岡</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/aichi/')"
            :external="isExternal('/clothes/chubu/aichi/')"
            class="pref"
          >愛知</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/gifu/')"
            :external="isExternal('/clothes/chubu/gifu/')"
            class="pref"
          >岐阜</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chubu/mie/')"
            :external="isExternal('/clothes/chubu/mie/')"
            class="pref"
          >三重</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/kinki/')"
          :external="isExternal('/clothes/kinki/')"
          class="area"
        >近畿</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/kinki/shiga/')"
            :external="isExternal('/clothes/kinki/shiga/')"
            class="pref"
          >滋賀</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kinki/kyoto/')"
            :external="isExternal('/clothes/kinki/kyoto/')"
            class="pref"
          >京都</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kinki/osaka/')"
            :external="isExternal('/clothes/kinki/osaka/')"
            class="pref"
          >大阪</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kinki/hyogo/')"
            :external="isExternal('/clothes/kinki/hyogo/')"
            class="pref"
          >兵庫</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kinki/nara/')"
            :external="isExternal('/clothes/kinki/nara/')"
            class="pref"
          >奈良</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kinki/wakayama/')"
            :external="isExternal('/clothes/kinki/wakayama/')"
            class="pref"
          >和歌山</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/chugoku/')"
          :external="isExternal('/clothes/chugoku/')"
          class="area"
        >中国</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/chugoku/okayama/')"
            :external="isExternal('/clothes/chugoku/okayama/')"
            class="pref"
          >岡山</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chugoku/hiroshima/')"
            :external="isExternal('/clothes/chugoku/hiroshima/')"
            class="pref"
          >広島</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chugoku/tottori/')"
            :external="isExternal('/clothes/chugoku/tottori/')"
            class="pref"
          >鳥取</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chugoku/shimane/')"
            :external="isExternal('/clothes/chugoku/shimane/')"
            class="pref"
          >島根</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/chugoku/yamaguchi/')"
            :external="isExternal('/clothes/chugoku/yamaguchi/')"
            class="pref"
          >山口</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/shikoku/')"
          :external="isExternal('/clothes/shikoku/')"
          class="area"
        >四国</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/shikoku/tokushima/')"
            :external="isExternal('/clothes/shikoku/tokushima/')"
            class="pref"
          >徳島</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/shikoku/kagawa/')"
            :external="isExternal('/clothes/shikoku/kagawa/')"
            class="pref"
          >香川</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/shikoku/ehime/')"
            :external="isExternal('/clothes/shikoku/ehime/')"
            class="pref"
          >愛媛</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/shikoku/kouchi/')"
            :external="isExternal('/clothes/shikoku/kouchi/')"
            class="pref"
          >高知</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/kyushu/')"
          :external="isExternal('/clothes/kyushu/')"
          class="area"
        >九州</NuxtLink><div
          class="list"
        >
          <NuxtLink
            :to="getNuxtLink('/clothes/kyushu/fukuoka/')"
            :external="isExternal('/clothes/kyushu/fukuoka/')"
            class="pref"
          >福岡</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kyushu/saga/')"
            :external="isExternal('/clothes/kyushu/saga/')"
            class="pref"
          >佐賀</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kyushu/nagasaki/')"
            :external="isExternal('/clothes/kyushu/nagasaki/')"
            class="pref"
          >長崎</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kyushu/oita/')"
            :external="isExternal('/clothes/kyushu/oita/')"
            class="pref"
          >大分</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kyushu/kumamoto/')"
            :external="isExternal('/clothes/kyushu/kumamoto/')"
            class="pref"
          >熊本</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kyushu/miyazaki/')"
            :external="isExternal('/clothes/kyushu/miyazaki/')"
            class="pref"
          >宮崎</NuxtLink><NuxtLink
            :to="getNuxtLink('/clothes/kyushu/kagoshima/')"
            :external="isExternal('/clothes/kyushu/kagoshima/')"
            class="pref"
          >鹿児島</NuxtLink>
        </div><NuxtLink
          :to="getNuxtLink('/clothes/okinawa/')"
          :external="isExternal('/clothes/okinawa/')"
          class="area"
        >沖縄</NuxtLink>
        <div
          class="list"
        />
      </div>
    </div>
  </section>
</template>

  <style lang="scss" scoped>
  .clothesSearch {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .inner {
      display: flex;
      flex-direction: column;
      gap: 15px;
      padding: 10px;
      background-color: #EEF1F8;
    }
    .form {
      position: relative;
      border: 2px solid #3569C0;
      background-color: #FFF;
      border-radius: 100vmax;
      .search {
        display: flex;
        align-items: stretch;
      }
      .input {
        flex: 1;
        padding-inline: 10px;
        font-size: 18px;
        line-height: 38px;
        outline: none;
      }
      .submit {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        padding-left: 5px;
        padding-right: 10px;
        background-color: #3569C0;
      }
    }
    .contents {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
      .area {
        color: #3569C0;
        font-size: 16px;
        font-weight: 600;
        line-height: 1em;
        text-decoration: underline;
      }
      .list {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
      }
      .pref {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 8px;
        border-radius: 5px;
        background-color: #FFF;
        box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
        color: #303030;
        font-size: 16px;
        font-weight: 600;
        line-height: 1em;
        text-decoration: underline;
      }
    }
    @media (any-hover: hover) {
      .form {
        .submit {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
      }
      .contents {
        .area {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
        .pref {
          transition: opacity .2s ease-in-out;
          &:hover {
            opacity: .6;
          }
        }
      }
    }
  }
  </style>
